import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { ACCOUNTS_QUERY_KEY } from '../AccountsConstants';

export enum SimpleLinkStatusDTO {
  Good,
  Pending,
  Broken,
  Updating,
}

export interface AccountDTO {
  AccountId: string;
  AccountName: string;
  AccountType: number;
  Balance: number;
  Category: string;
  DataAggregationLinkId: number;
  Description: string;
  ExternalAccountId: string;
  InstitutionId: number;
  InstitutionName: string;
  IsLinked: boolean;
  LastGoodSync: string;
  ShowAccount: boolean;
  SyncAccountValueEnabled: boolean;
  SyncAssetAllocationEnabled: boolean;
  SyncCostBasisEnabled: boolean;
  SyncPositionsEnabled: boolean;
  SyncSourceLabel: null;
  SyncTransactionsEnabled: boolean;
}

export enum AggregatorIdDTO {
  Plaid = 2,
  Akoya = 3,
}

export interface InstitutionDTO {
  Accounts: AccountDTO[];
  Balance: number;
  Challenges: null;
  ConfigInstructions: null;
  ExternalLastGoodSync: string;
  ExternalLinkId: string;
  ExternalStatus: string;
  ExternalUserId: string;
  InstitutionId: string;
  InstitutionLinkId: number;
  InstitutionName: string;
  LastGoodSync: string;
  ExpirationDate: string | null;
  SimpleLinkStatus: SimpleLinkStatusDTO;
  Username: string;
  DataAggregatorId: AggregatorIdDTO | null;
  IsReadOnly: boolean;
}

interface InstitutionsResponseDTO {
  Institutions: InstitutionDTO[];
}

const fetchLinks = async (clientId: string): Promise<InstitutionsResponseDTO> =>
  authFetch(
    urlWithParams('/Consumer/AccountsLinks', {
      clientId,
    }),
  );

export const MANAGE_LINKS_QUERY_KEY = 'manageLinks';

export const useLinksQuery = ({ clientId }: { clientId: string }) => {
  return useQuery([ACCOUNTS_QUERY_KEY, MANAGE_LINKS_QUERY_KEY, clientId], () =>
    fetchLinks(clientId),
  );
};
